module.exports = __webpack_public_path__ + "static/media/usdt.eac1f7bb.svg";